import { ROUTES } from "@/config/types";
import type { AppConfigResponse } from "@/services/configService";
import { getInitialAppConfig } from "@/utils/appConfigStorage";
import { PayloadAction, createSlice } from "@reduxjs/toolkit"

interface Interface {
    isLoading: boolean;
    isSplashScreenLoading: boolean;
    navigation?: ROUTES;
    config: AppConfigResponse | any;
    isConfigLoading: boolean;
    configError: string | null;
}

const initialState: Interface = {
    isLoading: false,
    isSplashScreenLoading: true,
    navigation: undefined,
    config: getInitialAppConfig(),
    isConfigLoading: false,
    configError: null,
}

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload
        },
        setIsSplashScreenLoading(state, action) {
            state.isSplashScreenLoading = action.payload
        },
        setNavigation(state, action) {
            state.navigation = action.payload
        },
        setConfig(state, action: PayloadAction<AppConfigResponse | null>) {
            state.config = action.payload
        },
    },

})

export const { setIsLoading, setIsSplashScreenLoading, setNavigation, setConfig } = appSlice.actions
export default appSlice.reducer
